import flatpickr from 'flatpickr';

class EventsDonConference {
    init() {
        this.initChoices();
        this.onChangeConferenceId();
        this.onChangeCategoryId();
        this.onChangePositionId();
        this.onChangeParentId();
        this.onChangeBranchId();
        this.initFlatpickr();
    }

    initChoices() {
        let choicesSelector = $('select.choices');
        $.each(choicesSelector, function(){
            new Choices($(this)[0], {
                allowHTML: true,
                itemSelectText: '',
                shouldSort: false
            });
        })
    }

    onChangeConferenceId() {
        let conferenceSelector = $('#import-conference-id');
        conferenceSelector.on('change', function(){
           $(document).find('[name="conference_id"]').val($(this).val())
        });
    }

    onChangePositionId() {
        let positionSelector = $('#position-field');
        positionSelector.on('change', function(){
            let positionField = $(document).find('[name="position_field"]');
            if($(this).is(':checked')){
                positionField.val(1)
            } else {
                positionField.val(0)
            }
        });
    }

    onChangeCategoryId() {
        let categorySelector = $('#category-field');
        categorySelector.on('change', function(){
            let categoryField = $(document).find('[name="category_field"]');
            if($(this).is(':checked')){
                categoryField.val(1)
            } else {
                categoryField.val(0)
            }
        });
    }

    onChangeBranchId() {
        let branchSelector = $('#branch-field');
        branchSelector.on('change', function(){
            let branchField = $(document).find('[name="branch_field"]');
            if($(this).is(':checked')){
                branchField.val(1)
            } else {
                branchField.val(0)
            }
        });
    }

    onChangeParentId() {
        let parentIdSelector = $('#import-parent-id');
        parentIdSelector.on('change', function(){
            let parentField = $(document).find('[name="parent_field"]');
            parentField.val($(this).val())
        });
    }

    initFlatpickr() {
        let dateTarget = typeof target != 'undefined' ? target : 'today'
        let dateTargetEnd = typeof targetEnd != 'undefined' ? targetEnd : 'today'
        let defaultDate = typeof selectedRange != 'undefined' ? selectedRange : [new Date(), new Date()]

        flatpickr('.flatpickr', {
            altInput: true,
            altFormat: "F j, Y",
            dateFormat: "Y-m-d"
        });

        flatpickr('.flatpickr-range', {
            mode: 'range',
            altInput: true,
            altFormat: "F j, Y",
            dateFormat: "Y-m-d"
        });

        flatpickr('.attendance-date', {
            altInput: true,
            altFormat: "F j, Y",
            dateFormat: "Y-m-d",
            maxDate: dateTargetEnd,
            enable: [
                {
                    from: dateTarget,
                    to: dateTargetEnd
                }
            ]
        });

        flatpickr('.attendance-date-range', {
            mode: 'range',
            altInput: true,
            altFormat: "F j, Y",
            dateFormat: "Y-m-d",
            maxDate: dateTargetEnd,
            enable: [
                {
                    from: dateTarget,
                    to: dateTargetEnd
                }
            ],
            defaultDate: defaultDate,
        });
    }
}

export default EventsDonConference.prototype
